/* TURBO: Hide impossible swatches + correct availability + auto-pick first available Size + prevent stuck hidden Frame selection */
(function ($) {
  if (!window.Shopify || !$) return;

  var AUTO_PICK_FLAG = "__autoPickingSize";

  function getCheckedValue(parent, optionIndex) {
    var $checked = $(
      `${parent} .swatch[data-option-index="${optionIndex}"] input[type="radio"]:checked`
    );
    if ($checked.length) return $checked.val();

    var $sel = $(`${parent} .single-option-selector:eq(${optionIndex})`);
    return $sel.length ? $sel.val() : null;
  }

  // ✅ NEW: if current checked value in a group becomes hidden, pick the first visible option
  function ensureVisibleChecked(parent, optionIndex) {
    var $group = $(`${parent} .swatch[data-option-index="${optionIndex}"]`);
    if (!$group.length) return;

    var $checked = $group.find('input[type="radio"]:checked').first();
    if ($checked.length) {
      var $checkedLabel = $checked.next("label");
      // if checked label is hidden, uncheck it
      if ($checkedLabel.length && !$checkedLabel.is(":visible")) {
        $checked.prop("checked", false);
      }
    }

    // if nothing checked now, pick first visible+enabled
    var $checkedNow = $group.find('input[type="radio"]:checked').first();
    if ($checkedNow.length) return;

    var $firstBox = $group.find(".swatch-element:visible").first();
    if (!$firstBox.length) return;

    var $firstRadio = $firstBox.prevAll('input[type="radio"]').first();
    var $firstLabel = $firstBox.prevAll("label").first();

    if ($firstRadio.length && !$firstRadio.prop("disabled")) {
      if ($firstLabel.length) $firstLabel.trigger("click");
      else $firstRadio.prop("checked", true).trigger("change");
    }
  }

  // IMPORTANT: uses checked swatches to compute the correct key (fixes wrong sizes)
  window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
    var key = "root";

    if (selectorIndex === 1) {
      key = getCheckedValue(parent, 0) || "root";
    } else if (selectorIndex === 2) {
      var v1 = getCheckedValue(parent, 0) || "";
      var v2 = getCheckedValue(parent, 1) || "";
      key = `${v1} / ${v2}`;
    }

    var availableOptions = (window.Shopify.optionsMap && window.Shopify.optionsMap[key]) || [];

    // ✅ DEFENSIVE (2026-08-08): optionsMap is built by the main theme bundles.
    // If they failed to run (JS error, dropped script request), the map is empty
    // and the loop below would hide and disable EVERY Frame Option and Size
    // swatch — the "empty option groups" bug. No availability data means we
    // know nothing, and the only safe state is everything visible and enabled.
    if (!availableOptions.length) {
      $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
        var $box = $(this);
        $box.show().removeClass("soldout");
        $box.prevAll("label").first().show();
        $box.prevAll('input[type="radio"]').first().prop("disabled", false);
      });
      return;
    }

    // Your markup is: input + label + .swatch-element (siblings)
    $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
      var $box = $(this);
      var val = $box.attr("data-value");

      var $radio = $box.prevAll('input[type="radio"]').first();
      var $label = $box.prevAll("label").first();

      if ($.inArray(val, availableOptions) !== -1) {
        // ✅ possible -> show all 3 + enable
        $box.show().removeClass("soldout");
        $label.show();
        $radio.prop("disabled", false);
      } else {
        // ❌ impossible -> hide all 3 + disable + uncheck
        $box.hide().addClass("soldout");
        $label.hide();
        $radio.prop("checked", false).prop("disabled", true);
      }
    });
  };

  function refreshDependentOptions(parent) {
    window.Shopify.updateOptionsInSelector(1, parent);
    window.Shopify.updateOptionsInSelector(2, parent);
  }

  function autoPickFirstSize(parent) {
    var $form = $(parent);
    if (!$form.length) return;
    if ($form.data(AUTO_PICK_FLAG)) return;

    var $size = $(`${parent} .swatch[data-option-index="2"]`);
    if (!$size.length) return;

    // Keep current if it’s still visible+enabled
    var $current = $size.find('input[type="radio"]:checked').first();
    if ($current.length && !$current.prop("disabled")) {
      var $currentLabel = $current.next("label");
      if ($currentLabel.length && $currentLabel.is(":visible")) return;
    }

    // Find first visible size BOX, then click its LABEL (Turbo selection)
    var $firstBox = $size.find(".swatch-element:visible").first();
    if (!$firstBox.length) return;

    var $firstRadio = $firstBox.prevAll('input[type="radio"]').first();
    var $firstLabel = $firstBox.prevAll("label").first();

    if ($firstRadio.length && !$firstRadio.prop("disabled")) {
      $form.data(AUTO_PICK_FLAG, true);

      if ($firstLabel.length) {
        $firstLabel.trigger("click");
      } else {
        $firstRadio.prop("checked", true).trigger("change");
      }

      setTimeout(function () {
        $form.removeData(AUTO_PICK_FLAG);
      }, 0);
    }
  }

  // When any swatch changes, refresh.
  // ✅ If Pieces changes, make sure Frame Option isn’t stuck on a hidden choice.
  // ✅ If Pieces or Frame changes, auto-pick Size.
  $(document).on("change", ".swatch input[type='radio']", function () {
    var $form = $(this).closest(".product_form");
    if (!$form.length) return;

    var parent = "#" + $form.attr("id");
    var optIndex = $(this).closest(".swatch").attr("data-option-index");

    // If Pieces changed, some Frame Options may disappear -> fix hidden checked Frame Option
    if (optIndex === "0") {
      // refresh first so options hide/show, then ensure frame is valid
      refreshDependentOptions(parent);
      ensureVisibleChecked(parent, 1);
      // refresh again after fixing frame
      refreshDependentOptions(parent);
      // then pick size
      setTimeout(function () {
        autoPickFirstSize(parent);
      }, 120);
      return;
    }

    // Normal flow
    refreshDependentOptions(parent);

    if (optIndex === "0" || optIndex === "1") {
      setTimeout(function () {
        autoPickFirstSize(parent);
      }, 120);
    }
  });

  // On load: build correct availability and auto-pick size, then show UI.
  // ✅ DEFENSIVE (2026-08-08): optionsMap may not exist yet (or ever, if the main
  // bundles failed). Retry briefly; if it never appears, run anyway — the
  // empty-map guard above turns the filter into "show everything".
  document.addEventListener("DOMContentLoaded", function () {
    var tries = 0;
    function initForms() {
      var mapReady = window.Shopify && window.Shopify.optionsMap &&
        Object.keys(window.Shopify.optionsMap).length > 0;
      if (!mapReady && tries < 10) {
        tries += 1;
        setTimeout(initForms, 300);
        return;
      }
      $("[data-product-form]").each(function () {
        var $form = $(this);
        var parent = "#" + $form.attr("id");

        refreshDependentOptions(parent);
        ensureVisibleChecked(parent, 1);
        refreshDependentOptions(parent);

        autoPickFirstSize(parent);

        setTimeout(function () {
          $form.addClass("is-variant-ready");
        }, 180);
      });
    }
    initForms();
  });

})(window.jQuery);

